import {set, asyncUpdate} from "reduxigen";
import store from "../store/store";
import * as api from '../constants/API'

export const updateQuery = set("searchQuery");

export const setRedirectedFromHome = set("redirectedFromHome");

export const setCurrentResult = set("currentResult");

const clearResults = set("results");

const loadFachgruppen = () => {
    return fetch(api.API_fachgruppen, {
        method: "GET",
    })
        .then((data) => data.json())
        .then((data) => {
            return {
                fachgruppen: data
            };
        });
};

export const updateFachgruppen = asyncUpdate("fachgruppen", loadFachgruppen);

const makeSearchRequest = (query, skip = 0) => {
    store.dispatch(clearResults([]));

    store.dispatch(updateQuery({
        what: query.what,
        where: query.where,
        when: query.when,
        allowedDocs: query.allowedDocs,
    }));

    let currState = store.getState();

    let url = process.env.API_URL + '/appointments?docGroupID=' + query.what;

    url += '&earliestTimestamp=' + query.when;
    url += '&limit=10';
    url += '&skip=' + skip;
    if(query.allowedDocs && query.allowedDocs.length > 0) {
        url += '&allowedocs=' + JSON.stringify(query.allowedDocs)
    }

    return fetch(url, {
        method: "GET",
    })
        .then((data) => data.json())
        .then((data) => {
            return {
                results: data
            }
        });
};

export const runSearch = asyncUpdate("results", makeSearchRequest);

const loadMoreResultsRequest = () => {
    let currState = store.getState();
    let query = currState.searchQuery;

    let url = process.env.API_URL + '/appointments?docGroupID=' + query.what;

    url += '&earliestTimestamp=' + query.when;
    url += '&limit=10';
    url += '&skip=' + currState.results.length;
    if(query.allowedDocs && query.allowedDocs.length > 0) {
        url += '&allowedocs=' + JSON.stringify(query.allowedDocs)
    }

    return fetch(url, {
        method: "GET",
    })
        .then((data) => data.json())
        .then((data) => {
            if(data.length === 0) {
                return {
                    reachedResultsEnd: true
                }
            }
            const results = currState.results.concat(data);

            return {
                results: results
            }
        });
};

export const loadMoreResults = asyncUpdate("results", loadMoreResultsRequest);



// WEBPACK FOOTER //
// ./src/actions/SearchActions.js